import { render } from "./DialogReserva.vue?vue&type=template&id=ad2a185e&scoped=true"
import script from "./DialogReserva.vue?vue&type=script&lang=js"
export * from "./DialogReserva.vue?vue&type=script&lang=js"

import "./DialogReserva.vue?vue&type=style&index=0&id=ad2a185e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad2a185e"]])

export default __exports__